import _ from 'lodash'

const B_TV_TABS_CONFIG = {
    element: _.select( '.c-section--tv-solutions-masonry .extra__info .tabs' ),
    triggers: _.selectAll( '.c-section--tv-solutions-masonry .extra__info .tabs .tab__triggers button' ),
    contents: _.selectAll( '.c-section--tv-solutions-masonry .extra__info .tabs .tab__contents .tab__content' )
}

export default B_TV_TABS_CONFIG